import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Glyph from 'components/Glyph.jsx';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import GroupStore from 'groups/stores/GroupStore';
import List from 'components/List.jsx';
import ListItem from 'components/ListItem.jsx';
import React from 'react';
import ScrollableArea from 'components/ScrollableArea.jsx';
import Text from 'components/Text.jsx';
import RecipientToken from 'chat/components/UniversalComposerRecipientToken.jsx';
import DeprecatedTokenizerTypeahead from 'components/DeprecatedTokenizerTypeahead.jsx';

import cx from 'classnames';
import getMatcher from 'utils/getMatcher';
import { membershipDescriptionFor } from 'groups/lib/groupDisplay';

import styles from './styles/AnnouncementComposerRecipientsInput.css';

class AnnouncementComposerRecipientsInput extends React.Component {
  static propTypes = {
    selectedGroupCodes: React.PropTypes.array,
    onChange: React.PropTypes.func,
  };

  static defaultProps = {
    selectedGroupCodes: [],
    onChange: () => {},
  };

  getFilter = (query) => {
    const matcher = getMatcher(query);
    return groupCode => {
      if (this.props.selectedGroupCodes.includes(groupCode)) {
        return false;
      }
      const group = GroupStore.getGroupForCode(groupCode);
      return matcher([
        group.getName(),
        group.getCode(),
      ]);
    };
  }

  loadData = () => {
    const groups = GroupStore.getPostableGroups();
    const groupCodes = groups.models.map(g => g.getCode());
    return Promise.resolve(groupCodes);
  }

  renderTypeaheadList(items) {
    return (
      <ScrollableArea
        useBodyChildrenHeight
        className={styles.typeaheadScrollArea}>
        <List className={styles.typeaheadList}>
          {items}
        </List>
      </ScrollableArea>
    );
  }

  renderTypeaheadItem(groupCode, highlighted, query, onSelect) {
    const group = GroupStore.getGroupForCode(groupCode);
    return (
      <ListItem
        onClick={() => onSelect()}
        key={group.id}
        className={cx({
          [styles.typeaheadItem]: true,
          [styles.highlightedTypeaheadItem]: highlighted,
        })}>
        <FlexibleBlock flex="right">
          <GroupAvatar className={styles.itemAvatar} group={group} size="small" />
          <div>
            <Text
              className={styles.itemName}
              color="pitch"
              size="xsmall"
              weight="semibold"
              truncate>
              <GroupName group={group} />
            </Text>
            <Text className={styles.itemDescription} color="koala" size="xxsmall" truncate>
              {membershipDescriptionFor(group)}
            </Text>
          </div>
        </FlexibleBlock>
      </ListItem>
    );
  }

  renderTypeaheadSelectAllItem(highlighted, onSelect) {
    return (
      <ListItem
        onClick={onSelect}
        className={cx({
          [styles.typeaheadItem]: true,
          [styles.selectAllTypeaheadItem]: true,
          [styles.highlightedTypeaheadItem]: highlighted,
        })}>
        <Text color="pitch" size="xsmall" weight="semibold" truncate>
          <Glyph className={styles.sendallGlyph} name="plus" />
          Send to all classes
        </Text>
      </ListItem>
    );
  }

  renderNoMoreItems() {
    return (
      <ListItem className={styles.noMoreItems} key="noMoreItems">
        <Text color="pitch" size="xsmall" weight="semibold">
          No more classes
        </Text>
      </ListItem>
    );
  }

  renderNoResults(query) {
    return (
      <ListItem className={styles.noResults} key="noResults">
        <Text color="pitch" size="xsmall" weight="semibold">
          No classes found for &quot;{query}&quot;
        </Text>
      </ListItem>
    );
  }

  renderToken(groupCode) {
    const group = GroupStore.getGroupForCode(groupCode);
    return (
      <RecipientToken>
        <GroupAvatar group={group} size="xsmall" />
        <GroupName group={group} />
      </RecipientToken>
    );
  }

  render() {
    return (
      <DeprecatedTokenizerTypeahead
        {...this.props}
        className={this.props.className}
        prompt="To:"
        placeholder="Select one or more classes"
        value={this.props.selectedGroupCodes}
        onChange={this.props.onChange}
        dataSource={this.loadData}
        dataFilterFactory={this.getFilter}
        listRenderer={this.renderTypeaheadList}
        itemRenderer={this.renderTypeaheadItem}
        selectAllItemRenderer={this.renderTypeaheadSelectAllItem}
        noMoreItemsRenderer={this.renderNoMoreItems}
        noResultsRenderer={this.renderNoResults}
        tokenRenderer={this.renderToken}
      />
    );
  }
}

export default AnnouncementComposerRecipientsInput;



// WEBPACK FOOTER //
// ./src/groups/components/AnnouncementComposerRecipientsInput.jsx